import {
    Component,
    ElementRef, EventEmitter,
    Input,
    OnDestroy,
    OnInit, Output,
    ViewChild
} from '@angular/core';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-season-banner',
    templateUrl: './season-banner.component.html',
    styleUrls: ['./season-banner.component.scss']
})
export class SeasonBannerComponent implements OnInit, OnDestroy {

    @Input() channel: any;
    @Input() isFirst: boolean = false;
    @Input() currentFocus = false;

    @Output() rowFocused = new EventEmitter<void>();

    logo: string;
    background: string;

    @ViewChild('seasonBanner')
    seasonBanner: ElementRef;

    @ViewChild('slider')
    slider: ElementRef;

    destroy = new Subject<void>();

    constructor() {
    }

    ngOnInit(): void {
        const {images} = this.channel;
        this.logo = images.find(x => x.type === 'logo')?.url;
        this.background = images.find(x => x.type === 'hero-web-slim')?.url ?? images.find(x => x.type === 'hero-web')?.url;
    }

    ngOnDestroy() {
        this.destroy.next();
        this.destroy.complete();
    }

}
